import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

const FILE_STORAGE_KEY = KEYS.fileStorage.getFilesByTicket();

type Props = {
  ticketId?: number;
  fetch?: boolean;
};

function useGetImagesByTicket({ ticketId, fetch = false }: Props) {
  const { showApiError } = useGlobalContext();
  const { fileStorage: fileStorageApi } = useApiContext();
  const { t } = useTranslation('global');

  const images = useQuery(
    [FILE_STORAGE_KEY, ticketId],
    () =>
      fileStorageApi.files.getFilesByTicket({
        ticketId,
        fileType: 2, // Es dos porque es la imagen
        pageNumber: 0,
        pageSize: 9999
      }),
    {
      select: (data) => data?.data.data.items,
      onError: (error) =>
        showApiError(error, t('ticket.ticketDetail.failedImages')),
      enabled: !!ticketId && fetch,
      refetchOnWindowFocus: false
    }
  );

  return {
    images
  };
}

export default useGetImagesByTicket;
